import { render } from "./SelectionMatrixView.vue?vue&type=template&id=44419c30&scoped=true"
import script from "./SelectionMatrixView.vue?vue&type=script&lang=js"
export * from "./SelectionMatrixView.vue?vue&type=script&lang=js"

import "./SelectionMatrixView.vue?vue&type=style&index=0&id=44419c30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44419c30"]])

export default __exports__